import React, { useState, useEffect } from 'react';

export const StepStart = (props) => {

    const {nextStep} = props;

    return <div className="m-form__step m-form__step--start">
        <div className="m-form__container">
            <h2 className="m-form__header">Wniosek o Ramową Umowę Sprzedaży z&nbsp;odroczonym terminem płatności</h2>
            <div className="m-form__content">
                <h3 className="m-form__subheader">Dla kogo*</h3>
                <ul className="m-form__list">
                    <li>Jednostki budżetowe (Instytucje, Urzędy i Spółki Państwowe lub Samorządowe)</li>
                    <li>Pozostałe podmioty (zarejestrowani podatnicy VAT) działające min. 12 miesięcy:
                        <ul className="m-form__sublist">
                            <li>JDG - Jednoosobowa działalność gospodarcza</li>
                            <li>Spółki (cywilna, z o.o., akcyjna/itp)</li>
                            <li>Organizacja Społeczna (Fundacja, Stowarzyszenie)</li>
                        </ul>
                    </li>
                </ul>
                <p>*W przypadku, gdy Wnioskodawcą nie jest Jednostka budżetowa lub termin odroczenia jest dłuższy niż 15 dni wniosek może być rozpatrywany we współpracy z Instytucją Finansującą (Faktor)</p>
                
            </div>
            <button className="m-form__btn m-form__btn--start" onClick={()=>{nextStep(1)}}>Zaczynam wypełniać wniosek o kartę Partner</button>
        </div>
    </div>
}

